import { IndividSale } from '../../interfaces/interfaces';

import './styles.scss';

export function IndSale({ salesforce, storeName, storeId, authorName, quant, refer, color, date }: IndividSale) {
  return (
    <div className="sale ">
      <div className="itens-container">
        <div className="itens-sales">
          <span className="title">LOJA:</span>
          {storeName}
        </div>
        <div className="itens-sales">
          <span className="title">CNPJ:</span>
          {storeId}
        </div>
        <div className="itens-sales">
          <span className="title">REPRES.:</span>
          {salesforce}
        </div>
        <div className="itens-sales">
          <span className="title">NÚMERO:</span>
          {quant}
        </div>
        <div className="itens-sales">
          <span className="title">REF.:</span>
          {refer}
        </div>
        <div className="itens-sales">
          <span className="title">COR:</span>
          {color}
        </div>
        <div className="itens-sales">
          <span className="date-title">{date}</span>
        </div>
      </div>
    </div>
  );
}